import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";
import { PlusCircle, X } from "lucide-react";

type Props = {
  label: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
};

const RhfMultiInput = ({
  label,
  name,
  required = false,
  disabled = false,
  ...props
}: Props) => {
  const { control, register, watch } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    name,
    control,
  });

  // Ensure at least one field always exists
  React.useEffect(() => {
    if (fields.length === 0) {
      append("");
    }
  }, [fields, append]);

  return (
    <FormField
      control={control}
      name={name}
      render={() => (
        <FormItem className="relative space-y-0">
          <div className="flex items-center justify-between">
            {label && (
              <FormLabel>
                {label}
                {required ? "*" : ""}
              </FormLabel>
            )}

            <PlusCircle
              className="w-5 h-5 cursor-pointer text-primary"
              onClick={() => append("")}
            />
          </div>

          <FormControl>
            <div className="space-y-1.5">
              {fields.map((field, index) => (
                <div key={field.id} className="flex items-center gap-2">
                  <Input
                    {...register(`${name}.${index}`)}
                    disabled={disabled}
                   
                    type="text"
                    // required={required}
                    {...props}
                  />

                  {/* Hide X if only 1 field */}
                  {fields.length > 1 && (
                    <X
                      className="w-4 h-4 cursor-pointer text-red-500"
                      onClick={() => remove(index)}
                    />
                  )}
                </div>
              ))}
            </div>
          </FormControl>

          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RhfMultiInput;
